<h1 mat-dialog-title>Freigabe erteilen</h1>
<div mat-dialog-content>
    <mat-stepper orientation="vertical">
        <mat-step>
            <ng-template matStepLabel>Freizugebener Betrieb</ng-template>
            <kiene-autocomplete
                [placeholder]="'Freizugebener Betrieb:'"
                [genericApiUrl]="apiBaseUrl + 'kunde/search.php'"
                [params]="sourceClientParams"
                [focus]="false"
                [openOnlyOnClick]="true"
                (elementSelected)="setClient($event)"
                [showClear]="true"
            ></kiene-autocomplete>
            <div class="one-row">
                <button mat-button matStepperNext>Weiter</button>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Empf&auml;nger VVVO</ng-template>
            <kiene-autocomplete
                [placeholder]="'Empf&auml;nger Betrieb:'"
                [genericApiUrl]="apiBaseUrl + 'kunde/search.php'"
                [params]="recipientParams"
                [focus]="false"
                [openOnlyOnClick]="true"
                (elementSelected)="setRecipient($event)"
                [showClear]="true"
            ></kiene-autocomplete>

            <mat-form-field>
                <mat-label>VVVO</mat-label>
                <input matInput type="text" [formControl]="vvvoCtrl" minlength="12" maxlength="15" />
                <span matSuffix>({{ vvvoCtrl.value?.length || 0 }}/15)</span>
            </mat-form-field>
            <div class="one-row step-actions-inline">
                <button mat-button matStepperNext>Weiter</button>
                <button mat-button matStepperPrevious>Zur&uuml;ck</button>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Freigabe erteilen</ng-template>
            <button mat-flat-button color="accent" (click)="freigabeErteilen()" [disabled]="!vvvoCtrl.valid || !kunde">
                Freigabe erteilen
            </button>
            <div class="one-row">
                <button mat-button matStepperPrevious>Zur&uuml;ck</button>
                <span class="spacer"></span>
            </div>
        </mat-step>
    </mat-stepper>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close(false)">Abbrechen</button>
</div>
